// External imports for registration.
import { useThrottleFn } from '@vueuse/core'
import { createApolloProvider } from '@vue/apollo-option'

import defaultClient from '@/apollo'
import useAuthenticationService from '@/auth'

export default defineNuxtPlugin(async (nuxtApp) => {
  const app = nuxtApp.vueApp

  // Create an apollo provider
  const apolloProvider = createApolloProvider({
    defaultClient
  })

  await useAuthenticationService()
  app.use(apolloProvider)

  // Add hooks for extending session on known events.
  if (typeof window !== 'undefined') {
    const extendSession = useThrottleFn(async () => {
      try {
        const { getSession } = useAuth()
        await getSession()
      } catch (ignore) {
        // We are just trying to renew session token here
      }
    }, 60 * 1000) // only send activity once a minute
    const events = ['click', 'keydown', 'mousemove', 'touchstart']
    events.forEach(event => window.addEventListener(event, extendSession))
  }
})
